import React, { useState, useEffect, useContext } from 'react';
import { BsPlusCircleFill } from "react-icons/bs"
import { FaPen } from "react-icons/fa"
import { Row, Col, Card } from 'react-bootstrap'
import { Link } from "react-router-dom";

import Get from '../../../api/Get'
import { ENCUESTA_ALL } from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import LoadingList from "../../../loader/LoadingList";
import TableSearch from '../../../components/TableSearch';
import ComponentModalErrorSever from '../../../components/ComponentModalErrorSever';


const translateUserType = (type) => {
    const obj ={
        Patient: 'Paciente',
        Doctor: 'Doctor'
    }
    return obj[type] ?? type
}

function EncuestaList({ url }){
    const [loading, setLoading] = useState(false)
    const [cuentas, setCuentas] = useState([])

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const { auth } = useContext(authContext)
    let accesToken = auth?.data?.access_token;

    //Cargar la lista de cuentas
    useEffect(() => {
        let mounted = true
        Get({url: ENCUESTA_ALL, access_token: accesToken})
        .then((resp) => {
            console.log(resp)
            if(mounted){
                setCuentas(resp.data.data.response.content)
                setLoading(false)
            }            
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
        return () => mounted = false
    }, [])

    const actions = (cell, row) => <div key={`acciones-${row?.id}`}>
        <ul key={row?.id} className="list-inline mb-0">
            <li className="list-inline-item">
                <Link to={`${url}/create?id=${row.id}`}>
                    <FaPen className='iconAction colorNaranja' />
                </Link>
            </li>            
        </ul>          
    </div>
        
    const columns = [
        {
            text: 'ID',
            dataField: 'id',
            hidden: true
        },  
        {
            text: 'Título',
            dataField: 'title',
            headerStyle: { width: '60%' },
        }, 
        {
            text: 'Tipo de usuario',
            dataField: 'userType',
            headerStyle: { width: '10%' },
            formatter: (cell) => `${translateUserType(cell)}`,
        }, 
        {
            text: 'ACTIVO',
            dataField: 'activo',
            headerStyle: {  width: '15%', textAlign: 'center' },
            style:{
                textAlign: 'center'
            },
            formatter: (cell) => `${cell ? 'Si': 'No'}`,
        }, 
        {
            dataField: '',
            text: 'ACCIONES',
            isDummyField: true,
            headerStyle: {  width: '15%', textAlign: 'center' },
            style:{
                textAlign: 'center'
            },
            formatter: actions,
        }
    ]

    return(<>
        { loading && <LoadingList texto='' /> }
        <Row>
            <Col xs="12" md="8">
                <h2 className="mb-0 title-top"> Encuesta </h2>
            </Col>
            <Col xs="12" md="4" className='text-right'>
                <Row className="align-items-center">
                    <Col>
                    </Col>
                    <Col xs="4" md="3">
                        <Link to={`${url}/create`}><BsPlusCircleFill className="add-btn"/></Link>                        
                    </Col>
                </Row>    
            </Col>
        </Row>
        <Row>
            <Col>
                <Card className="shadow-1 mt-3">
                    <Card.Body>
                        <TableSearch columns={columns} items={cuentas} className="th-text-uppercase"/>                                    
                    </Card.Body> 
                </Card>
            </Col>
        </Row>    
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />    
    </>)
}

export default EncuestaList